import { icons } from "../default_images/IconsList";
import { TeambookIcon } from "../default_images/TeambookIcon";
import PropTypes from "prop-types";

export const InfoTooltip = ({ content, style }) => {
  return <TeambookIcon name={icons.INFO} placement="right" tooltipTitle={content} style={style} />;
};

InfoTooltip.propTypes = {
  content: PropTypes.string.isRequired,
  style: PropTypes.object,
}
